fx.ns("filters.photofilters", class FocusFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);

        this.color = this.params.color;
        this.vignetteFocusSize = this.params.vignetteFocusSize || 1;
        this.contrastMount = this.params.contrastMount || 1;
        this.contrastMount2 = this.params.contrastMount2 || ( -(0.3 * this.params.contrastMount) + 0.3 );
        this.brightnessAmount = this.params.brightnessAmount || 1;
        this.specularConstant = this.params.specularConstant || 1;

    };

   
	filterFCN(add)
	{
        let flood = add.flood(this.color, 1)
            .attr({'x': 0,  'y' : 0, 'result' : 'blackfield'});
         
        let pointLight = new SVG.PointLight(this.SVGElement.width() / 2, this.SVGElement.height() / 2, Math.max(this.SVGElement.width(), this.SVGElement.height()) * this.vignetteFocusSize);

        add.specularLighting()
                .attr({'result': 'spotlight', 'lighting-color': '#FFFFFF', 'surfaceScale': 0,  'specularConstant' : this.specularConstant, 'specularExponent' : 120})
                .add( pointLight);

        add.blend('blackfield', 'spotlight', 'lighten')
	       .attr('result', 'mask');

        add.blend('mask', 'SourceGraphic', 'multiply')
            .attr('result', 'vignette-result');

       

        add.colorMatrix('matrix', [ this.brightnessAmount, 0, 0, 0, 0,
                                     0, this.brightnessAmount, 0, 0, 0,
                                     0, 0, this.brightnessAmount, 0, 0,
                                     0, 0, 0, 1, 0 ])
           .attr("in", "vignette-result")
           .attr("result", "colormatrix");

        add.componentTransfer({
                rgb: { type: 'linear', slope: this.contrastMount, intercept: this.contrastMount2 }
            }).attr("in", "colormatrix");

        this.elements.push(flood);
        this.elements.push(pointLight);
    
    }


    resize(width, height)
    {
       for (let i = 0; i < this.elements.length; i++)
       {
            if (this.elements[i].type == "fePointLight")
                this.elements[i].attr({ x: width / 2, y :height / 2, z : Math.max(width, height) * this.vignetteFocusSize  }); 
        }
    }
   


});